'use strict';
var $ = require('jquery');
var config = require('./config');

var $debugContainer = $('.debug-container');

function updateViews(idealChairAttributes, allChairs) {
    var properties = [];

    var $debugTable = $debugContainer.find('table');
    $debugTable.html('');

    var $attrRow = $('<tr><td>Chair</td></tr>');
    var $idealRow = $('<tr><td>Ideal</td></tr>');

    for (var prop in idealChairAttributes) {
        if (idealChairAttributes.hasOwnProperty(prop)) {
            properties.push(prop);
            // console.log("obj." + prop + " = " + idealChairAttributes[prop]);
            var $col = $('<td>' + prop + '</td>');
            $attrRow.append($col);

            var propVal = idealChairAttributes[prop];
            var val =  propVal !== null ? propVal : '–';

            var $idealcol = $('<td>' + val + '</td>');
            $idealRow.append($idealcol);
        }
    }
    var $distance = $('<td>distance from ideal</td>');
    var $disqualified = $('<td>Disqualified</td>');
    //display
    $attrRow.append($distance);
    $attrRow.append($disqualified);
    $debugTable.append($attrRow);
    $debugTable.append($idealRow);

    allChairs.forEach(function (chair, index) {
        var $chairRow = $('<tr><td>' + index + '. ' + chair.title + '</td></tr>');

        properties.forEach(function (prop) {
            var vals = chair.attributes[prop];
            var ideal = vals.ideal;
            var exact = vals.exact;
            var min = vals.min;
            var max = vals.max;

            var display = '';
            if (typeof exact === 'undefined' && typeof min === 'undefined'  && typeof max === 'undefined') {
                display = ideal;
            } else {
                if (typeof ideal !== 'undefined') {
                    display += 'ideal: ' + ideal + ' ';
                }
                if (typeof exact !== 'undefined') {
                    display += 'exact: ' + exact + ' ';
                }
                if (typeof min !== 'undefined') {
                    display += 'min: ' + min + ' ';
                }
                if (typeof max !== 'undefined') {
                    display += 'max: ' + max + ' ';
                }
            }
            // for (var prop2 in vals) {
            //     if (vals.hasOwnProperty(prop2)) {

            //     }
            // }

            $chairRow.append('<td>' + display + '</td>');
        });
        $chairRow.append('<td>' + chair.distance + '</td>');
        $chairRow.append('<td>' + !chair.qualified + '</td>');
        $debugTable.append($chairRow);
    });

    // debugger;
    // var $debugContainer = $('.debug-container');

    // $debugContainer.find('.debug-matches h4').html('Chair Rankings');
    // $debugContainer.find('.debug-ideal h4').html('Ideal Values');
    // $debugContainer.find('ul').html('');

    // allChairs.forEach(function (chair) {
    //     var scoreDisplay;
    //     var $chairli = $('<li></li>');
    //      $chairli.addClass('chair-match');
    //     if (chair.qualified === false) {
    //         scoreDisplay = ' : disqualified';
    //         $chairli.addClass('disqualified');
    //     } else {
    //         scoreDisplay = ' : ' + chair.distance;
    //     }

    //     $chairli.html(chair.title + scoreDisplay);


    //     $debugContainer.find('ul.debug-list').append($chairli);
    // });  


    // for (var attr in idealChairAttributes) {
    //     if (idealChairAttributes.hasOwnProperty(attr)) {
    //         var score = idealChairAttributes[attr];
    //         score = score === null ? '-' : score;
    //         var $chairli = $('<li>' + attr + ' : ' + score + '</li>');
    //         $debugContainer.find('ul.ideal-list').append($chairli);
    //     }
    // }


}

if (config.debug === true) {
    $debugContainer.show();
}


var api = {
    update: function(idealChairAttributes, allChairs) {
        updateViews(idealChairAttributes, allChairs);
    },
    toggle: function() {
        $debugContainer.toggle();
    }

};

module.exports = api;